import React, { Component } from 'react';
import Script from 'react-load-script';
import { withTranslation } from 'react-i18next';

import AccountService from '../../../Service/AccountService';

const locale = {
    'es-ES': 'es',
    'en-US': 'en',
    'tl': 'tl',
    'ceb': 'ceb'
};

const APP_CONFIG = window.AppConfig;
class Auth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTokenLoaded: false,
            disabledButton: true,
            initializeURL: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js',
            token: null
        };
    }

    onScriptError() {
        console.error('There was an issue loading the link-initialize.js script');
    }

    onScriptLoaded = () => {
        this.setState({ isTokenLoaded: true });
        this.linkHandler = window.Plaid.create({
            token: this.state.token !== null ? this.state.token : '',
            clientName: 'LendAmi',
            key: APP_CONFIG.PLAID_PUBLIC_KEY,
            env: APP_CONFIG.PLAID_ENV,
            product: ['auth'],
            onSuccess: (token, metadata) => {
                if (this.state.token !== null) {
                    this.props.OnSuccess(token, metadata, true);
                } else {
                    this.props.OnSuccess(token, metadata);
                }
            },
            onExit: this.handleOnExit,
            onLoad: this.handleOnLoad,
            // country_code: ['US'],
            language: locale[this.props.i18n.language] || 'en',
            linkCustomizationName: locale[this.props.i18n.language] || 'default'
        });

        this.setState({ disabledButton: false });
        if (!this.props.children) {
            this.linkHandler.open();
        }
    }

    handleOnClick = (event) => {
        if (this.props.onClick != null) {
            this.props.onClick(event);
        }
        if (this.linkHandler) {
            this.linkHandler.open();
        }
    }

    handleOnExit = () => {
        if (this.props.OnExit != null) {
            this.props.OnExit();
        }
    }

    handleOnLoad = () => {
        if (this.props.OnLoad != null) {
            this.props.OnLoad();
        }
    }

    onFetchPlaidLink = async () => {
        const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER_INFO'));
        if (currentUser.profile.account && currentUser.profile.account.plaid_status === 'ITEM_LOGIN_REQUIRED') {
            this.setState({ isTokenLoaded: true });
            const response = await AccountService.getTokenForPlaidLink(currentUser.profile.account.funding_source_id);
            this.setState({ token: response.public_token, isTokenLoaded: false });
        }
    }

    componentDidMount () {
        this.onFetchPlaidLink();
    }

    render() {
        return (
            <div>
                <span
                    className={this.props.className}
                    disabled={this.state.disabledButton}
                    onClick={this.handleOnClick}
                    style={{ paddingTop: '15px', paddingBottom: '20px' }}
                >
                    {this.props.children || ''}
                </span>
                {
                    !this.state.isTokenLoaded
                        ? <Script
                            onError={this.onScriptError}
                            onLoad={this.onScriptLoaded}
                            url={this.state.initializeURL}
                        />
                        : null
                }
            </div>
        );
    }
}

export default (withTranslation('DwollaPlaid')(Auth));
